import type { Rule, RuleObject } from 'antd/es/form';
import { t as trsl } from 'i18next';
import {
  FRENCH_PHONE_REGEX,
  FRENCH_POSTAL_CODE_REGEX,
  TEXT_ONLY_REGEX,
} from 'utils/regex';

export const requiredRule = {
  required: true,
  message: trsl('global:required'),
} satisfies Rule;

export const phoneRule = {
  validator: async (_rule: RuleObject, value?: string) => {
    if (!value) {
      return Promise.resolve();
    }

    return new RegExp(FRENCH_PHONE_REGEX).test(value)
      ? Promise.resolve()
      : Promise.reject(new Error(trsl('global:phone_invalid')));
  },
} satisfies Rule;

export const emailRule = {
  type: 'email',
  message: trsl('global:email_invalid'),
} satisfies Rule;

export const siretRules: Rule[] = [
  {
    len: 14,
    message: trsl('global:errors:siret_14_caracteres'),
  },
  {
    pattern: /^\d+$/,
    message: trsl('global:errors:siret_chiffres'),
  },
];

export function getFieldRules(
  t: (key: string) => string,
  options: {
    required?: boolean;
    email?: boolean;
    phone?: boolean;
    text_only?: boolean;
    postal_code?: boolean;
  },
): Rule[] {
  const rules: Rule[] = [];

  if (options.required) {
    rules.push(requiredRule);
  }
  if (options.email) {
    rules.push(emailRule);
  }

  if (options.phone) {
    rules.push(phoneRule);
  }

  if (options.text_only) {
    rules.push({
      pattern: new RegExp(TEXT_ONLY_REGEX),
      message: t('global:number_not_allowed'),
    });
  }

  if (options.postal_code) {
    rules.push({
      pattern: new RegExp(FRENCH_POSTAL_CODE_REGEX),
      message: t('global:postal_code_invalid'),
    });
  }

  return rules;
}
